import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.sass']
})
export class StepperComponent {

  @Input() step = 1;
  @Input() step2Active = true;
  @Input() step3Active = true;
  @Input() step4Active = true;
  @Input() datagGateActive = false;
  @Input() step4Available = false;

}
